import taskPipeline from './src/taskPipeline.vue'

export default taskPipeline
